
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-gradient-to-b from-gray-900 to-[#fe7222]/10 text-white pt-16 sm:pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-12 sm:mb-16">
          {/* Brand */}
          <div className="space-y-4 sm:space-y-6">
            <img
              src="https://static.readdy.ai/image/4e6d233a4d13eb9885bc14dac5e47a67/6fd14fe2a55165d4c4c555bc2c0cbfef.png"
              alt="Urban Drive"
              className="h-12 sm:h-14 w-auto"
            />
            <p className="text-sm sm:text-base text-gray-400 leading-relaxed">
              Location de voitures premium à Taza. Votre partenaire de confiance pour tous vos déplacements.
            </p>
            <div className="flex items-center gap-3 sm:gap-4">
              {[
                { icon: 'ri-whatsapp-line', link: 'https://wa.me/212667304231' },
                { icon: 'ri-facebook-circle-line', link: 'https://www.facebook.com/profile.php?id=61559900651568#' },
                { icon: 'ri-instagram-line', link: 'https://www.instagram.com/Urban.drive.cars/' },
                { icon: 'ri-tiktok-line', link: 'https://www.tiktok.com/@urban.drive.cars' }
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center backdrop-blur-xl bg-white/10 border border-white/20 rounded-full hover:bg-[#fe7222] hover:border-[#fe7222] transition-all duration-300 hover:scale-110 cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Liens Rapides</h3>
            <ul className="space-y-2 sm:space-y-3">
              {['Accueil', 'Notre Flotte', 'Tarifs', 'À Propos', 'Contact'].map((link, index) => (
                <li key={index}>
                  <a href="#" className="text-sm sm:text-base text-gray-400 hover:text-[#fe7222] transition-colors duration-300 cursor-pointer">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Nos Services</h3>
            <ul className="space-y-2 sm:space-y-3">
              {['Location courte durée', 'Location longue durée', 'Avec chauffeur', 'Livraison gratuite', 'Assurance complète'].map((service, index) => (
                <li key={index}>
                  <a href="#" className="text-sm sm:text-base text-gray-400 hover:text-[#fe7222] transition-colors duration-300 cursor-pointer">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Contact</h3>
            <ul className="space-y-3 sm:space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-lg text-[#fe7222]"></i>
                </div>
                <span className="text-sm sm:text-base text-gray-400">N 6, imm hassania, Taza 35000</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-lg text-[#fe7222]"></i>
                </div>
                <a href="tel:+212667304231" className="text-sm sm:text-base text-gray-400 hover:text-[#fe7222] transition-colors duration-300 cursor-pointer">
                  +212 667 304 231
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-lg text-[#fe7222]"></i>
                </div>
                <a href="mailto:urbandrive.rentcar@gmail.com" className="text-sm sm:text-base text-gray-400 hover:text-[#fe7222] transition-colors duration-300 cursor-pointer">
                  urbandrive.rentcar@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-lg text-[#fe7222]"></i>
                </div>
                <span className="text-sm sm:text-base text-gray-400">Lun - Dim: 8h - 20h</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs sm:text-sm text-gray-400 text-center sm:text-left">
              © {currentYear} Urban Drive. Tous droits réservés.
            </p>
            <div className="flex items-center gap-4 sm:gap-6">
              <a href="#" className="text-xs sm:text-sm text-gray-400 hover:text-[#fe7222] transition-colors duration-300 cursor-pointer whitespace-nowrap">
                Conditions d'utilisation
              </a>
              <a href="#" className="text-xs sm:text-sm text-gray-400 hover:text-[#fe7222] transition-colors duration-300 cursor-pointer whitespace-nowrap">
                Confidentialité
              </a>

            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
